import React from 'react'
import { connect } from 'react-redux'
import { NavigationState, NavigationProps } from './types'

class Navigator extends React.Component<NavigationProps> {

  render(): React.ReactNode {
    const { navigation }: { navigation: NavigationState } = this.props
    const route: string = navigation.history[navigation.index]
    const Element: React.ElementType = navigation.routes[route]
    return <Element />
  }

}

const mapStateToProps = (state: { navigation: NavigationState }): { navigation: NavigationState } => ({
  navigation: state.navigation
})

export default connect(mapStateToProps)(Navigator)
